module.exports = __webpack_public_path__ + "app-static/img/banner-02.890a88cc.jpg";